module.exports = __webpack_public_path__ + "static/media/file-audio.dba7aeb0.svg";